import PropTypes from 'prop-types'
import React from 'react'
import SearchCategory from './SearchCategory'

import './styles.css'

function SearchCategories({ categories = [], active = null, select = () => {} }) {
  return (
    <div id="SearchCategories">
      <div className="wrapper">
        {categories.map((category, categoryIndex) => (
          <SearchCategory
            key={categoryIndex}
            name={category}
            active={active}
            select={(cat) => select(cat)}
          />
        ))}
      </div>
    </div>
  )
}

SearchCategories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.string,
  select: PropTypes.func
}

export default SearchCategories
